import Parse from 'parse'
Parse.initialize(process.env.APP_ID)
Parse.serverURL = process.env.SERVER_URL
export default Parse



// WEBPACK FOOTER //
// ./src/services/parse.js